import React, { useState, useEffect } from 'react';
import { AuthServiceLogout, GetUniqueUserService } from 'services';
import { Link } from 'react-router-dom';

import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
export const UserDropDown = () => {

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userName, setUserName] = useState('');
  const [userId, setUserId] = useState(false);

  useEffect(() => {
    setUserId(localStorage.getItem('@userId'));
  }, []);

  useEffect(() => {
    userId && GetUniqueUserService(userId).then((response) => {
      response && setUserName(response.name);
    });
  }, [userId]);

  const user = {
    id: userId,
    name: userName,
    isLogged: userId || false,
  };

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleClickLogout = () => {
    AuthServiceLogout();
  };

  return (
    <Dropdown nav isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle nav caret className="user-dropdown text-dark">
        {user.name}
      </DropdownToggle>
      <DropdownMenu>
        {user.isLogged && (
          <>
            <DropdownItem>
              <Link to={`/usuarios/${user.id}`}>Editar</Link>
            </DropdownItem>
            <DropdownItem>
              <Link onClick={handleClickLogout}>
                Sair
              </Link>
            </DropdownItem>
          </>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};
